import Api from "@/api/index"

export default {
  name: "ResHelper",
  map: {},
  res: {},
  //用于下拉选择
   getResArr:  async function (key) {
    let _this = this;
    await _this.initRes(key);
    let resMap = _this.map[key];
    let resArr=[];
    if (resMap != null) {
      for (let val in resMap) {
        let res = {};
        res.value = val;
        res.label = resMap[val];
        resArr.push(res);
      }
    }
    return resArr;
  },
  getVal: function (key, val) {
    var _this = this;
    _this.initRes(key);
    var resMap = _this.map[key];
    if (resMap != null) {
      var displayValue = resMap[val] ? resMap[val] : val;
      return displayValue;
    } else {
      return 'reskey:' + key + ' 未加载';
    }
  },
  initRes: async function (key) {
    var _this = this;
    if (!_this.map[key]) {
      await _this.getResSync(key);   
    }
  },
  async getResSync (key) {
    var _this = this;   
    const { data } = await Api.queryResourceList({key})    
    var datas = data.list;
    var resMap = {};
    var resList = [];
    datas.forEach(function (it) {
      resMap[it.realValue] = it.displayValue;
      resList.push(it);
    });
    _this.map[key] = resMap;
    _this.res[key] = resList;
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/ResHelper.js